import { render } from "./SchemaMarkupCheckbox.vue?vue&type=template&id=5408c00c"
import script from "./SchemaMarkupCheckbox.vue?vue&type=script&lang=js"
export * from "./SchemaMarkupCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__